import React, {useState, useEffect} from 'react';
import { Container, Row, Col, FormLabel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import UserService from './services/user.serviceaux';
import { PageHeader } from "./AuxiliaryFunctions";
import { FcFilingCabinet } from "react-icons/fc";
import { PiDoorDuotone } from "react-icons/pi";
import { MdKitchen } from "react-icons/md";
import Sidebar from './Sidebar';
import './App.css';
import { useSelector } from "react-redux";
import TopBar from './TopAndSideBar';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const NewFastQuote = (props) => {    
    const { user: currentUser } = useSelector((state) => state.auth) || {};
    const [userRoles, setUserRoles] = useState([]);    

    useEffect(() => {
        getUserRoles(currentUser.id);
        //console.log(props);
    }, [currentUser]);

    const getUserRoles = (userId) => {
        UserService.get(userId)
        .then(response => {
            //console.log(response);
            //console.log(userId);
            setUserRoles(response.data[0].roles.map ((a) => a.id));
        })      
        .catch(e => {
            // a type error is logged in the browser dev tools here :(
            // the cause of the error is that props.user is empty at the beginning...
            // but it doesn't seem to be affecting anything.
            // so, I think we can safely ignore it.. or not?
            console.log(e);
        });
    };

    return (
        <>
        <TopBar />
        <Sidebar style={{position:'fixed', top:'51px', left:'0', zIndex:'10'}} sidebarStatus={false}/>
        <Container style={{width:"80%", marginTop:"200px"}}>
            {/*<PageHeader />*/}

            <Container>
                <h4 className='mb-4 header-label'>New Fast Quote</h4>
                <Col>
                    <Container style={{display:"flex",justifyContent:"center",flexWrap:"wrap",gap:"50px"}}>
                        {/* The arrays before each link represent the role Ids who are allowed to use each link */}
                        {([3].some(i => userRoles.includes(i))) && (
                        <Link to={'/new-cabinet-fast-quote'}>
                            <Container>                                
                                <Row>
                                    {<FcFilingCabinet size={'60px'}/>}                                    
                                </Row>
                                <Row>Cabinet Fast Quote</Row>                            
                            </Container>
                        </Link>
                        )}
                        {([3,6].some(i => userRoles.includes(i))) && (
                        <Link to={'/new-door-fast-quote'}>
                            <Container>
                                <Row>
                                    {<PiDoorDuotone size={'60px'}/>}
                                </Row>
                                <Row>Door Fast Quote</Row>                            
                            </Container>
                        </Link>)}                    

                        {([3,6].some(i => userRoles.includes(i))) && (
                        <Link to={'/new-kitchen-fast-quote'}>
                            <Container>
                                <Row>
                                    {<MdKitchen size={'60px'}/>}
                                </Row>
                                <Row>Door Kitchen Quote</Row>                            
                            </Container>
                        </Link>)}   

                    </Container>
                </Col>
            </Container>                
            <hr/>


            <Container>
                <h4 className='mb-4 header-label'>View/Edit Existing Fast Quote</h4>
                <Col>
                    <Container style={{display:"flex",justifyContent:"center",flexWrap:"wrap",gap:"50px"}}>
                        {/* The arrays before each link represent the role Ids who are allowed to use each link */}
                        {([3].some(i => userRoles.includes(i))) && (
                        <Link to={'/view-cabinet-fast-quoting'}>
                            <Container>
                                <Row>{<FcFilingCabinet size={'60px'}/>}</Row>
                                <Row>Cabinet Fast Quote</Row>                            
                            </Container>
                        </Link>)}

                        {([3,6].some(i => userRoles.includes(i))) && (
                        <Link to={'/view-door-fast-quoting'}>
                            <Container>
                                <Row>{<PiDoorDuotone size={'60px'}/>}</Row>
                                <Row>Door Fast Quote</Row>                            
                            </Container>
                        </Link>)}                    

                    </Container>
                </Col>
            </Container>             
        </Container>

        </>
      );
}
  
export default NewFastQuote;
